import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD } from '../routes/paths';
// components
import LoadingScreen from '../components/LoadingScreen';

// ----------------------------------------------------------------------

GuestProtect.propTypes = {
  children: PropTypes.node
};

export default function GuestProtect({ children }) {
  const { isLoading, isAuthenticated } = useAuth();

  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!isAuthenticated || url !== null) return; // Guard clause to prevent re-renders

    const lastVisited = sessionStorage.getItem('last-visited');

    if (lastVisited) {
      const lastVisitedObj = JSON.parse(lastVisited);
      // Avoid redirecting to root ("/") or login page after authentication
      const redirectUrl =
        lastVisitedObj.url === '/' || lastVisitedObj.url === '/auth/login'
          ? PATH_DASHBOARD.root
          : lastVisitedObj.url;
      setUrl(redirectUrl);
    } else {
      setUrl(PATH_DASHBOARD.root);
    }
    setUrl(PATH_DASHBOARD.root);
  }, [isAuthenticated, url]);

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (isAuthenticated && url) {
    return <Navigate to={url} />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
